import {
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(MuiTextField)<MuiTextFieldProps>(
  ({ theme: { palette, spacing, colors } }) => ({
    '& .MuiFormHelperText-root': {
      position: 'absolute',
      bottom: spacing(-1.9),
    },
    '& .MuiOutlinedInput-root': {
      /** Adornment */
      '& .inputAdornment.MuiInputAdornment-root': {
        margin: '0',
        padding: spacing(2.7, 0),
        borderLeft: `${spacing(0.1)} solid ${colors.container as string}`,
      },

      '&.MuiInputBase-sizeSmall .inputAdornment.MuiInputAdornment-root': {
        padding: spacing(2, 0),
      },

      /** Adornment Icon Button */
      '& .inputAdornment .MuiIconButton-root': {
        margin: spacing(0, 0.8, 0, 0.7),
      },

      /** On Hover */
      /** Adornment */
      '&:hover .inputAdornment.MuiInputAdornment-root': {
        borderColor: colors.containerState,
      },

      /** On Focus */
      /** Adornment */
      '&.Mui-focused .inputAdornment.MuiInputAdornment-root': {
        borderColor: colors.container,
      },

      /** Disabled */
      /** Adornment */
      '&.Mui-disabled .inputAdornment.MuiInputAdornment-root': {
        borderColor: palette.action.disabledBackground,
      },

      /** Adornment Icon Button */
      '&.Mui-disabled .inputAdornment .MuiIconButton-root': {
        color: palette.action.disabledBackground,
      },

      /** Error */
      /** Adornment */
      '&.Mui-error .inputAdornment.MuiInputAdornment-root': {
        borderColor: palette.error.main,
      },
    },
  })
);

export default StyledTextField;
